import { ReactNode } from 'react'
import BenefitCss from './Benefit.css'
interface IProps {
	icon?: ReactNode
	name?: string
}
export default function BenefitTag({ name, icon }: IProps) {
	return (
		<BenefitCss>
			<div className='icon'>{icon}</div> {name}
		</BenefitCss>
	)
}
